import classnames from 'classnames'

interface LabelProps {
  groupLabel: string
  groupName: string
  rightAligned: boolean
  color: boolean
}

const COLOR_MAP: Record<string, { text: string; border: string; background: string }> = {
  indices: { text: 'text-gray-400', border: 'border-gray-400', background: 'bg-gray-400' },
  energy: { text: 'text-violet-400', border: 'border-violet-400', background: 'bg-violet-400' },
  bonds: { text: 'text-blue-400', border: 'border-blue-400', background: 'bg-blue-400' },
  softs: { text: 'text-teal-300', border: 'border-teal-300', background: 'bg-teal-300' },
  metals: { text: 'text-yellow-200', border: 'border-yellow-200', background: 'bg-yellow-200' },
  meats: { text: 'text-pink-400', border: 'border-pink-400', background: 'bg-pink-400' },
  grains: { text: 'text-orange-300', border: 'border-orange-300', background: 'bg-orange-300' },
  currencies: { text: 'text-purple-300', border: 'border-purple-300', background: 'bg-purple-300' },
}

export function PlainLabel({ groupName, groupLabel, color }: LabelProps) {
  return (
    <div
      className={classnames('font-sans text-2xs font-bold xl:text-sm', {
        'text-gray-500': !color,
        [COLOR_MAP[groupName].text]: color,
      })}
    >
      {groupLabel}
    </div>
  )
}

export function SideLabel({ groupName, groupLabel, rightAligned, color }: LabelProps) {
  return (
    <div
      className={classnames('absolute top-0 rotate-180 font-sans text-2xs font-medium xl:text-sm', {
        '-left-5':
          !rightAligned || ['indices', 'grains', 'currencies', 'energy', 'metals', 'softs'].includes(groupName),
        '-right-5': rightAligned && ['bonds', 'meats'].includes(groupName),

        'text-gray-500 dark:text-gray-400': !color,
        [COLOR_MAP[groupName].text]: color,
      })}
      style={{ writingMode: 'vertical-lr' }}
    >
      {groupLabel}
    </div>
  )
}

export function LineLabel({ groupName, groupLabel }: LabelProps) {
  return (
    <div className="flex items-center font-sans text-2xs text-gray-600 font-medium xl:text-sm">
      {groupLabel}
      <div className={classnames(COLOR_MAP[groupName].background, 'ml-2 h-1 flex-1')} />
    </div>
  )
}

export function LineWithEndingLabel({ groupName, groupLabel }: LabelProps) {
  return (
    <div className="flex items-baseline px-2 font-sans text-2xs text-gray-600 font-medium xl:text-sm">
      {groupLabel}
      <div className={classnames(COLOR_MAP[groupName].border, 'ml-2 h-1.5 flex-1 border-r-2 border-t-2')} />
    </div>
  )
}
